
<template>
  <div class="myMenu" id="myMenu">
    <ul>
      <li
        v-for="item in val"
        :key="item"
        :class="activeClass == item ? 'active':''"
        @mouseover="mouseover($event,item)"
      >
        <router-link to>
          <slot :name="item"></slot>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ['val'],
  name: 'MyMenu',
  data() {
    return {
      activeClass: 1
    }
  },
  methods: {
    // 通过mouseover事件控制当前显示的商品分类，1为该类别的热门商品
    mouseover(e, val) {
      this.activeClass = val
    }
  },
  watch: {
    // 向父组件传过去当前要显示的商品分类，从而更新商品列表
    activeClass: function(val) {
      this.$emit('fromChild', val)
    }
  }
}
</script>
<style scoped>
#myMenu ul {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 0;
  margin: 0;
}
#myMenu li {
  float: none;
  margin-left: 0;
}

#myMenu a:hover {
  color: #10B981;
  border-bottom: 2px solid #10B981;
}

#myMenu .active a {
  color: #10B981;
  border-bottom: 2px solid #10B981;
}
@media (max-width: 900px) {
  #myMenu a {
    font-size: 12px;
    padding: 6px 0;
  }
  #myMenu ul {
    gap: 10px;
  }
}
</style>
